import WasmController from "react-lib/frameworks/WasmController";

import Cookies from "js-cookie";

// APIs
import GeneratePermitAPI from "issara-sdk/apis/GeneratePermitAPI_users";


// Utils
import moment from "moment-timezone";

export type Props = {};

export type State = {
};

export const StateInitial: State = {
  permitToken: {}
};

export type Event =
  | { message: "GetPermit"; params: any }
;

export type Data = {
  division?: number;
};

export const DataInitial = {};

type Handler = (controller: WasmController<State, Event, Data, Props>, params?: any) => any;

export const GetPermit: Handler = async (controller, params) => {

  console.log('GetPermit controller.apiToken: ', controller.apiToken);
  console.log('GetPermit controller: ', controller);
  if (controller.apiToken) { 
    const [data, error] = await GeneratePermitAPI.get({ params, apiToken: controller.apiToken });
      if (error) {
        console.error("GetPermit error:", error);
        return;
    }
    controller.setState({ permitToken: data });
  }
}
